import React, { useEffect } from "react";
import styled from "styled-components";

import { ModalWrapper } from "../../../../common/common.styles";
import { PendingIcon } from "../../../../common/assets/icons/catalogueIcons";
import Button from "../../../../../../library/otherButton/Button";

const PendingModal = ({ closeModal, feedbackMessage, onSuccessButtonClick }) => {
    useEffect(() => {
        document.body.classList.add("backdrop-init");

        return () => {
            document.body.classList.remove("backdrop-init");
        };
    }, [closeModal]);

    return (
        <div className="modal">
            <div className="fadeIn animated modal-backdrop">
                <PendingModalWrapper>
                    <h3>Pending</h3>
                    <div>
                        <PendingIcon />
                    </div>
                    <p>
                        Order {feedbackMessage.orderId} sent to <b>{feedbackMessage.deviceName}</b>{" "}
                        for checkout. We’ll notify you when this bill has been settled.
                    </p>
                    <Button text="Okay" width="100px" onButtonClick={onSuccessButtonClick} />
                </PendingModalWrapper>
            </div>
        </div>
    );
};

const PendingModalWrapper = styled(ModalWrapper)`
    padding: 46px 40px;
    width: 415px;
    display: flex;
    flex-direction: column;
    align-items: center;
    h3 {
        margin-bottom: 52px;
    }
    p {
        font-size: 1rem;
        font-weight: 400;
        line-height: 20px;
        margin-top: 60px;
        margin-bottom: 44px;
        color: #000;
        text-align: center;
        b {
            font-weight: 800;
        }
    }
`;

export default PendingModal;
